/* eslint-disable max-len */
import { NAVBAR_HEIGHT } from 'library/globals';

export const rateCalculatorStyles = () => ({
    main: {
        fontFamily: 'Open Sans',
        letterSpacing: 0,
        height: `calc(100vh - ${NAVBAR_HEIGHT}px)`,
        overflowY: 'auto',
        padding: '16px 12px',
    },
    headingTitle: {
        fontSize: 18,
        fontWeight: 700,
        color: '#111111',
        margin: '0 0 16px 0',
    },
    colData: {
        backgroundColor: '#FCFCFC',
        padding: '12px 20px',
        border: '1px solid #DDDFE9',
        borderRadius: 4,
        height: 'fit-content',
    },
    calculateButton: {
        marginTop: 16,
        background: '#082E78',
        borderColor: '#082E78',
    },
    // Services container
    servicesMain: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        '& .ant-collapse-borderless > .ant-collapse-item': {
            border: 'none',
        },
        '& .ant-collapse-borderless': {
            background: 'inherit',
            width: '100%',
        },
        '& .ant-collapse > .ant-collapse-item > .ant-collapse-header': {
            padding: '0px',
        },
        '& .ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box': {
            paddingTop: '8px !important',
            paddingBottom: '0px !important',
        },
    },
    panel: {
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 4,
        width: '100%',
        '& .ant-empty-normal': {
            margin: 'auto',
        },
    },
    servicesHeader: {
        width: '100%',
        fontSize: 16,
        gap: 8,
        display: 'flex',
        alignItems: 'center',
        fontWeight: 600,
        backgroundColor: '#fefefe',
        padding: '4px 8px',
        border: '1px solid #ebebeb',
        borderRadius: '4px',
        marginBottom: '4px',
    },
    // Service cards
    serviceOption: {
        width: '100%',
        border: '1px solid #e0e0e0',
        borderRadius: '6px',
        padding: '12px',
        paddingRight: '16px',
        marginBottom: '12px',
        alignContent: 'center',
        boxSizing: 'border-box',
    },
    unavailableCard: {
        width: '100%',
        flexDirection: 'column',
    },
    serviceCard: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
    },
    serviceItem: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        marginRight: 0,
        fontSize: 14,
        fontWeight: 550,
    },
    serviceInfoRow: {
        display: 'flex',
    },
    serviceCardRight: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
    },
    // TAT / delivery time
    columnNew: {
        display: 'flex',
        alignItems: 'center',
        gap: 4,
    },
    tatIcon: {
        height: 18,
        width: 18,
    },
    tatNew: {
        width: '100%',
        fontSize: 12,
        marginRight: 6,
    },
    deliveryTimeNew: {
        width: '100%',
        flexDirection: 'row',
        fontSize: 12,
        display: 'flex',
        textAlign: 'left',
        marginRight: 4,
    },
    deliveryTimeNewNA: {
        fontSize: 12,
        opacity: 0,
    },
    // Rate / price
    finalPriceNew: {
        width: '100%',
        flexDirection: 'row',
        fontSize: 14,
        fontWeight: 600,
        display: 'flex',
    },
    // Alternate options toggle
    alternateOptions: {
        display: 'flex !important',
        gap: '4px',
        alignItems: 'center',
        backgroundColor: '#f5f5f5',
        borderRadius: 8,
        padding: '1px 6px',
        marginTop: '2px !important',
        fontSize: '10px',
        cursor: 'pointer',
    },
    arrowIcon: {
        display: 'inline-block',
        transition: 'transform 0.3s ease',
        cursor: 'pointer',
    },
    // Error list
    errorList: {
        border: '1px solid #eae9e0',
        backgroundColor: '#fffcf3',
        borderRadius: 8,
        padding: '4px 8px',
        marginTop: '4px',
    },
    errorHeading: {
        fontSize: 12,
        color: '#ac811a',
        display: 'flex',
        gap: '4px',
        alignItems: 'center',
    },
    errorListCollapse: {
        width: '100%',
        overflow: 'hidden',
        transition: 'max-height 0.3s ease',
    },
    // Unavailable card header
    unavailableCardHeader: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'nowrap',
    },
    unavailableServiceName: {
        flex: 1,
        fontSize: 14,
        fontWeight: 550,
        opacity: 0.5,
        minWidth: 0,
    },
    // Expand / collapse all buttons
    expandCollapseOptions: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
        justifySelf: 'end',
        marginRight: '4px',
        cursor: 'pointer',
    },
    expandAllHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        fontSize: 12,
    },
    // Scroll containers
    servicesRelativeContainer: {
        position: 'relative',
    },
    scrollContainerAvailable: {
        maxHeight: '360px',
        overflowY: 'scroll',
    },
    scrollContainerUnavailable: {
        maxHeight: '1000px',
        overflowY: 'scroll',
        width: '100%',
    },
    // Scroll shadows
    shadowBase: {
        position: 'absolute',
        left: 0,
        width: '100%',
        height: '20px',
        pointerEvents: 'none',
        zIndex: 1,
        transition: 'opacity 0.3s ease',
    },
    shadowTop: {
        top: 0,
        background: 'linear-gradient(to top, rgba(255,255,255,0), rgba(0,0,0,0.05))',
        borderRadius: '4px 4px 0 0',
    },
    shadowBottom: {
        bottom: 0,
        background: 'linear-gradient(to bottom, rgba(255,255,255,0), rgba(0,0,0,0.05))',
        borderRadius: '0 0 4px 4px',
    },
});
